export const base = 'https://view.horsevision.cn'

// 授权
export const authorizationPath = '/huatai-securities/web/index.php?r=api/api/login-wx'

// 判断是否授权
export const isLoginPath = '/huatai-securities/web/index.php?r=api/api/get-user-info'

// 提交问券调查
export const surveyPath = '/huatai-securities/web/index.php?r=api/api/survey'

// 抽奖
export const pricePath = '/huatai-securities/web/index.php?r=api/api/get-gift'

// 领取奖品
export const receivePricePath = '/huatai-securities/web/index.php?r=api/api/receive-my-prize'

// 我的奖品
export const myPricePath = '/huatai-securities/web/index.php?r=api/api/get-my-prize'

// config
export const configPath = '/huatai-securities/web/index.php?r=api/api/get-share-config'

//获取积分

export const setCredit = '/huatai-securities/web/index.php?r=api/api/set-credit'
